import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { DialogTransition } from "../../utilities/DialogTransition";

const ConfirmationPopup = ({ open, handleClose, handleSubmit, title, buttonText, children }) => (
  <Dialog open={open} TransitionComponent={DialogTransition} onClose={handleClose}>
    <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column" }}>
      <DialogTitle
        sx={{
          height: "64px",
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #d3d3d3",
        }}>
        <span style={{ fontSize: "1.125rem", fontWeight: "bold" }}>{title}</span>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", minWidth: "300px", paddingTop: "20px" }}>{children}</Box>
      </DialogContent>

      <DialogActions
        sx={{
          borderTop: "1px solid #d3d3d3",
          padding: "20px",
          gap: "10px",
        }}>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancel
        </Button>

        {/* ✅ This will now work */}
        {buttonText && (
          <Button variant="contained" color="error" type="submit">
            {buttonText}
          </Button>
        )}
      </DialogActions>
    </Box>
  </Dialog>
);

ConfirmationPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ConfirmationPopup;
